import React from 'react';
import { SyncOutlined } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';
import { pipelineInProgress } from '@utils/pipelines';
import { PIPELINE_STATUS_LABELS, PipelineStatusCodes } from '@constants/pipelines';
import { IPipeline } from '@redux/types/types';
import styles from './pipelineStatusTag.module.scss';

const TAG_TEST_ID = 'pipeline_statusTag';

interface Props {
  pipeline: IPipeline;
}

const PipelineStatusTag = (props: Props) => {
  const { pipeline } = props;
  const { status: queryStatus } = pipeline;

  if (queryStatus === PipelineStatusCodes.DEPLOYMENT_FAILED)
    return (
      <Tag data-testid={TAG_TEST_ID} color="error" className={styles.tag} bordered={false}>
        {PIPELINE_STATUS_LABELS[PipelineStatusCodes.DEPLOYMENT_FAILED]}
      </Tag>
    );
  if (queryStatus === PipelineStatusCodes.UNDEPLOYMENT_FAILED)
    return (
      <Tag data-testid={TAG_TEST_ID} color="error" className={styles.tag} bordered={false}>
        {PIPELINE_STATUS_LABELS[PipelineStatusCodes.UNDEPLOYMENT_FAILED]}
      </Tag>
    );

  if (queryStatus === PipelineStatusCodes.IDLE) {
    return (
      <Tooltip title="Pipeline is on standby to save resources. Run a query to activate it.">
        <Tag data-testid={TAG_TEST_ID} className={styles.tag} bordered={false}>
          {PIPELINE_STATUS_LABELS[PipelineStatusCodes.IDLE]}
        </Tag>
      </Tooltip>
    );
  }

  if (queryStatus === PipelineStatusCodes.ACTIVATING) {
    return (
      <Tag
        data-testid={TAG_TEST_ID}
        icon={<SyncOutlined spin />}
        color="processing"
        className={styles.tag}
        bordered={false}
      >
        {PIPELINE_STATUS_LABELS[PipelineStatusCodes.ACTIVATING]}
      </Tag>
    );
  }

  if (pipelineInProgress(pipeline.status))
    return (
      <Tag
        data-testid={TAG_TEST_ID}
        icon={<SyncOutlined spin />}
        color="processing"
        className={styles.tag}
        bordered={false}
      >
        {queryStatus === PipelineStatusCodes.DEPLOYMENT_IN_PROGRESS ||
        queryStatus === PipelineStatusCodes.DEPLOYMENT_SCHEDULED
          ? PIPELINE_STATUS_LABELS[PipelineStatusCodes.DEPLOYMENT_IN_PROGRESS]
          : PIPELINE_STATUS_LABELS[PipelineStatusCodes.UNDEPLOYMENT_IN_PROGRESS]}
      </Tag>
    );

  if (queryStatus !== PipelineStatusCodes.DEPLOYED)
    return (
      <Tag data-testid={TAG_TEST_ID} className={styles.tag} bordered={false}>
        {PIPELINE_STATUS_LABELS[PipelineStatusCodes.UNDEPLOYED]}
      </Tag>
    );

  // For deployed pipelines
  return (
    <Tag color="success" className={styles.tag} data-testid={TAG_TEST_ID} bordered={false}>
      {PIPELINE_STATUS_LABELS[PipelineStatusCodes.DEPLOYED]}
    </Tag>
  );
};

export default PipelineStatusTag;
